/**
 * sling-offer-tiered.js — Tiered quantity-discount offer selector.
 * Manages 4 tier cards (1–4 bags), dynamic color picker rows,
 * and add-to-cart with line-item properties for discount resolution.
 *
 * Items are added at the variant's Shopify price. The displayed tier
 * pricing requires a matching Shopify automatic discount or Script
 * that reads _bundle_tier / _bundle_unit_price line-item properties.
 */
(function () {
  'use strict';

  var container = document.getElementById('SlingOfferTiered');
  if (!container) return;

  var dataEl = document.getElementById('SlingTieredData');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);

  var variants = data.variants;
  var defaultVariantId = data.defaultVariantId;
  var tiers = data.tiers;
  var regularUnitPrice = data.regularUnitPrice;
  var maxQty = 4;

  // Build lookups
  var variantMap = {};
  var colorToVariant = {};
  variants.forEach(function (v) {
    variantMap[v.id] = v;
    if (!colorToVariant[v.option1]) {
      colorToVariant[v.option1] = v;
    }
  });

  // ── State ──
  var selectedTier = data.defaultTier;
  var bagVariantIds = [];
  for (var i = 0; i < maxQty; i++) {
    bagVariantIds.push(defaultVariantId);
  }

  // ── DOM refs ──
  var picker = document.getElementById('SlingTieredPicker');
  var pickerHeading = document.getElementById('SlingTieredPickerHeading');
  var ctaButton = document.getElementById('SlingTieredButton');
  var ctaLabel = ctaButton.querySelector('.sling-offer-cta__label');
  var ctaCompare = ctaButton.querySelector('.sling-offer-cta__compare');
  var ctaPrice = ctaButton.querySelector('.sling-offer-cta__price');
  var tierCards = container.querySelectorAll('.sling-tier-card');
  var bagRows = container.querySelectorAll('.sling-bag-row');

  var section = container.closest('.main-product-section') || document;
  var existingBuyButtons = section.querySelector('.block-product__buttons');

  // ── Helpers ──

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getCurrentTier() {
    return tiers[selectedTier - 1];
  }

  // ── Update functions ──

  function updateTierCards() {
    tierCards.forEach(function (card) {
      var tier = parseInt(card.getAttribute('data-tier'), 10);
      var radio = card.querySelector('.sling-tier-card__radio');
      if (tier === selectedTier) {
        card.classList.add('sling-tier-card--active');
        radio.classList.add('sling-tier-card__radio--checked');
      } else {
        card.classList.remove('sling-tier-card--active');
        radio.classList.remove('sling-tier-card__radio--checked');
      }
    });
  }

  function updateBagRows() {
    var tier = getCurrentTier();
    bagRows.forEach(function (row, index) {
      if (index < tier.qty) {
        row.style.display = '';
      } else {
        row.style.display = 'none';
      }

      var vid = bagVariantIds[index];
      var variant = variantMap[vid];
      if (!variant) return;

      var thumb = row.querySelector('.sling-bag-row__thumb img');
      var colorLabel = row.querySelector('.sling-bag-row__color');

      if (thumb && variant.image) {
        thumb.src = variant.image;
        thumb.alt = variant.option1;
      }
      if (colorLabel) {
        colorLabel.textContent = variant.option1;
      }

      row.querySelectorAll('.sling-swatch').forEach(function (s) {
        var sid = parseInt(s.getAttribute('data-variant-id'), 10);
        if (sid === vid) {
          s.classList.add('sling-swatch--active');
        } else {
          s.classList.remove('sling-swatch--active');
        }
      });
    });
  }

  function updatePickerHeading() {
    var tier = getCurrentTier();
    if (tier.qty === 1) {
      pickerHeading.textContent = 'Choose your color:';
    } else {
      pickerHeading.textContent = 'Choose your ' + tier.qty + ' colors:';
    }
  }

  function updateCTA() {
    var tier = getCurrentTier();
    if (tier.qty === 1) {
      ctaLabel.textContent = 'Add 1 Bag to Cart';
      ctaCompare.style.display = 'none';
      ctaCompare.textContent = '';
    } else {
      ctaLabel.textContent = 'Add ' + tier.qty + ' Bags to Cart';
      ctaCompare.textContent = formatMoney(regularUnitPrice * tier.qty);
      ctaCompare.style.display = '';
    }
    ctaPrice.textContent = formatMoney(tier.total);
  }

  function updateVisibility() {
    picker.style.display = '';
    if (existingBuyButtons) existingBuyButtons.classList.add('sling-hide-block');
  }

  function closeAllSwatchPanels() {
    bagRows.forEach(function (row) {
      row.querySelector('.sling-bag-row__swatches').style.display = 'none';
      row.querySelector('.sling-bag-row__change').textContent = 'Change color';
    });
  }

  function render() {
    updateTierCards();
    updateBagRows();
    updatePickerHeading();
    updateCTA();
    updateVisibility();
  }

  // ── Tier card selection ──
  tierCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selectedTier = parseInt(card.getAttribute('data-tier'), 10);
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      closeAllSwatchPanels();
      render();
    });
  });

  // ── Main swatch sync (event delegation) ──
  section.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.type !== 'radio') return;
    if (!target.closest('.block-product__variant-picker')) return;

    var colorValue = target.getAttribute('data-option-value');
    if (!colorValue) return;

    var matchingVariant = colorToVariant[colorValue];
    if (!matchingVariant) return;

    for (var j = 0; j < maxQty; j++) {
      bagVariantIds[j] = matchingVariant.id;
    }
    closeAllSwatchPanels();
    updateBagRows();
  });

  // ── Individual bag color accordion + swatch clicks ──
  bagRows.forEach(function (row, index) {
    var changeBtn = row.querySelector('.sling-bag-row__change');
    var swatchPanel = row.querySelector('.sling-bag-row__swatches');

    changeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = swatchPanel.style.display !== 'none';
      closeAllSwatchPanels();
      if (!isOpen) {
        swatchPanel.style.display = '';
        changeBtn.textContent = 'Close';
      }
    });

    row.querySelectorAll('.sling-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var vid = parseInt(swatch.getAttribute('data-variant-id'), 10);
        bagVariantIds[index] = vid;
        swatchPanel.style.display = 'none';
        changeBtn.textContent = 'Change color';
        updateBagRows();
      });
    });
  });

  // ── CTA add-to-cart ──
  ctaButton.addEventListener('click', function () {
    if (ctaButton.classList.contains('sling-offer-cta--loading')) return;
    ctaButton.classList.add('sling-offer-cta--loading');
    ctaButton.disabled = true;

    var tier = getCurrentTier();
    var items = [];
    for (var k = 0; k < tier.qty; k++) {
      items.push({
        id: bagVariantIds[k],
        quantity: 1,
        properties: {
          '_bundle_tier': String(selectedTier),
          '_bundle_unit_price': String(tier.unitPrice),
          '_bundle_qty': String(tier.qty)
        }
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (window.CartBenefits && window.CartBenefits.normalize) {
        window.CartBenefits.normalize();
      }

      var sections = ['cart-icon-bubble'];
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        var sid = cartDrawer.getAttribute('data-section-id');
        if (sid) sections.push(sid);
      }

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {},
          sections: sections,
          sections_url: window.location.pathname
        })
      });
    })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
    })
    .catch(function (err) {
      console.error('SlingOfferTiered: add-to-cart error', err);
    })
    .finally(function () {
      ctaButton.classList.remove('sling-offer-cta--loading');
      ctaButton.disabled = false;
    });
  });

  // ── Initialize ──
  render();
})();
